import React, { createContext, useContext, useState, useCallback } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react'; 

const NotificationContext = createContext(null);

const NotificationProvider = ({children}) => {
    const [notification, setNotification] = useState(null);
    const [timeoutId, setTimeoutId] = useState(null);

    const hideNotification = useCallback(() =>{
        if(timeoutId){
            clearTimeout(timeoutId)
        }
        setNotification(null);
        setTimeoutId(null);
    }, [timeoutId]);


    const showNotification = useCallback((message, type = 'success', duration = 4000) =>{
        if(timeoutId){
            clearTimeout(timeoutId);
        }

        setNotification({message,type});


        const newTimeoutId = setTimeout(() => {
      hideNotification();
    }, duration);
    setTimeoutId(newTimeoutId);
  }, [hideNotification, timeoutId]);


  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <NotificationPopup
        notification={notification}
        onClose={hideNotification}
      />
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};




const NotificationPopup = ({ notification, onClose }) => {
  if (!notification) return null;

  const isSuccess = notification.type === 'success';

  const baseClasses = 'fixed top-5 left-1/2 -translate-x-1/2 z-50 flex items-start gap-3 max-w-sm rounded-lg shadow-lg p-4';
  const colorClasses = isSuccess
    ? 'bg-emerald-50 border border-emerald-200'
    : 'bg-red-50 border border-red-200';
  
  const iconColor = isSuccess ? 'text-emerald-500' : 'text-red-500';

  return (
    <div className={`${baseClasses} ${colorClasses}`} role="alert">
      {/* Icon */}
      <div className={`flex-shrink-0 ${iconColor}`}>
        {isSuccess ? (
          <CheckCircle className="w-5 h-5" />
        ) : (
          <XCircle className="w-5 h-5" />
        )}
      </div>

      {/* Message */}
      <div className="flex-1 mr-4">
        <p className={`text-sm font-medium ${isSuccess ? 'text-emerald-800' : 'text-red-800'}`}>
          {isSuccess ? 'Success' : 'Error'}
        </p>
        <p className={`text-sm ${isSuccess ? 'text-emerald-700' : 'text-red-700'}`}>
          {notification.message}
        </p>
      </div>

      
      <button
        onClick={onClose}
        className={`flex-shrink-0 -mt-0.5 -mr-0.5 p-0.5 rounded-md ${isSuccess ? 'text-emerald-600 hover:bg-emerald-100' : 'text-red-600 hover:bg-red-100'}`}
      >
        <span className="sr-only">Close</span>
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

    

export default NotificationProvider